import { RewardsScreen } from '@/screens/diamonds/RewardsScreen'

export default function () {
  return <RewardsScreen />
}
